// extracted by mini-css-extract-plugin
export default {"news":"NewsItem_news__INe8M","news_title":"NewsItem_news_title__GD+WZ","news_img":"NewsItem_news_img__+tCvL","news_date":"NewsItem_news_date__KiM1y"};